import api from 'api';
import {
  getMaxLoadsRequestFromCache,
  saveMaxLoadsRequestToCache,
} from 'refactored/features/form/loads/loadsCache';

import { isEmpty } from 'utils/types';

const GET_MAXIMUM_ENDPOINT_URL = 'max_loads/';

const getMaximumOfLoads = async ({
  shipmentsWithLoads,
  shipmentsInOrder,
  maxEuPallets,
}) => {
  if (Object.values(shipmentsWithLoads).every((load) => isEmpty(load))) {
    return false;
  }

  const body = {
    shipments_order: shipmentsInOrder,
    shipments_loads: shipmentsWithLoads,
    ...(maxEuPallets && { max_eu_pallets: maxEuPallets }),
  };

  const requestKey = JSON.stringify(body);
  const maxLoadsFromCache = getMaxLoadsRequestFromCache(requestKey);
  if (maxLoadsFromCache !== null) {
    return maxLoadsFromCache;
  } else {
  }

  try {
    const { data } = await api.post(GET_MAXIMUM_ENDPOINT_URL, body);
    saveMaxLoadsRequestToCache(requestKey, data);
    return data;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export default getMaximumOfLoads;
